import { render, staticRenderFns } from "./NewAllAssets.vue?vue&type=template&id=3467de42&scoped=true"
import script from "./NewAllAssets.vue?vue&type=script&lang=js"
export * from "./NewAllAssets.vue?vue&type=script&lang=js"
import style0 from "./NewAllAssets.vue?vue&type=style&index=0&id=3467de42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467de42",
  null
  
)

export default component.exports